import React from "react";

import pill from "./../../../UI/general/pill.svg";
//import SidebargalleriesMobile from "./sidebarMobile.component";
import ContainerMobile from "./containerMobile.component";

interface Props {
  galleryData: any;
  colorsData: any;
  isGallery: boolean;
  handleGalleriesSelection: any;
  handleCloseGalleryModal: any;
}

interface State {
  isCollapsed: boolean;
  galleryItemSelected: string;
  rgbaColor: any;
  galleryIndexSelected: number;
}
//declare const window: any;

class GalleryModalMobile extends React.Component<Props, State> {
  render(): React.ReactNode {
    return (
        <div className={this.props.isGallery ? 'gallery-modal-container-mobile fade-in':'gallery-modal-container-mobile fade-out'}>
            <div 
            className='close-gallery-modal-mobile' 
            onClick={() => {
              this.setState({
                galleryIndexSelected: -1
              })
              this.props.handleCloseGalleryModal()
            }}
          >
            <img src={pill} alt=""/> 
          </div>
        {this.props.isGallery ? (
            <>
            <ContainerMobile 
              galleryData={this.props.galleryData}
              
              colorsData={this.props.colorsData}/>
            </>
        ) : null}
      </div>
    );
  }
}

export default GalleryModalMobile;
